export interface DiscontinuedNetwork {
  badge: string;
  primaryCTAText: string;
  primaryCTAUrl: string;
  learnMoreText: string;
  learnMoreUrl: string;
  description: string; // docs-card subtext override
}

// PDF: "URL for Learn more will take user to the docs (Link TBA)".
// Replace this placeholder when the announcement/docs URL is provided.
export const SUNSET_LEARN_MORE_URL = "https://stader.gitbook.io/stader/polygon-discontinued";

export const DISCONTINUED_NETWORKS: Record<string, DiscontinuedNetwork> = {
  polygon: {
    badge: "Discontinued",
    primaryCTAText: "Unstake Now",
    primaryCTAUrl: "https://www.staderlabs.com/polygon/stake/",
    learnMoreText: "Learn more",
    learnMoreUrl: SUNSET_LEARN_MORE_URL,
    description: "Unstake MaticX to receive POL",
  },
  bnb: {
    badge: "Discontinued",
    primaryCTAText: "Unstake Now",
    primaryCTAUrl: "https://www.staderlabs.com/bnb/stake/",
    learnMoreText: "Learn more",
    learnMoreUrl: SUNSET_LEARN_MORE_URL,
    description: "Unstake BNBx to receive BNB",
  },
};

export const getDiscontinued = (
  key?: string
): DiscontinuedNetwork | undefined =>
  key ? DISCONTINUED_NETWORKS[key.toLowerCase()] : undefined;

export const isDiscontinued = (key?: string): boolean =>
  Boolean(getDiscontinued(key));
